export default __webpack_public_path__ + "static/media/Avenir.2764bf91.ttc";